<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_contactInformationCopy')"
      width="1000px"
      :close-on-click-modal="false"
      class="app-main-inner edi-bill-search-selector"
    >
      <div class="filters">
        <el-form label-width="80px" label-position="left">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('Payment.businessNumber')">
                <el-input v-model="elForm.jobNo" no="jobNo" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_ShipperId')">
                <el-input v-model="elForm.shipper" no="shipper" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_ConsigneeId')">
                <el-input v-model="elForm.consignee" no="consignee" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_NotifyId')">
                <el-input v-model="elForm.notify" no="notify" />
              </el-form-item>
            </el-col>
            <el-col v-if="lob==='AI'" :span="8">
              <el-form-item :label="$t('SeaExport.MasterBillNo')">
                <el-input v-model="elForm.mbl" no="mbl" />
              </el-form-item>
            </el-col>
            <el-col v-if="lob==='AI'" :span="8">
              <el-form-item :label="$t('SeaExport.LoadingPort')">
                <cargo-advance-select
                  no="loadingPortCode"
                  filterable
                  :select-type="selectTypeNames.basic_data_Airport"
                  callback-method-type="value"
                  :default-value="elForm.loadingPortCode?elForm.loadingPortCode:''"
                  :callback-params="{key:'loadingPortCode'}"
                  style="flex:1"
                  @parentCallBack="obj=>{elForm.loadingPortCode=obj.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label-width="0">
                <el-button type="primary" no="search" @click="search">{{ $t('common.btn.query') }}</el-button>
                <el-button type="primary" no="reset" @click="reset">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="app-main-inner-row row-grid" style="min-height:350px;padding:0">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width:100%"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" no="confirm" @click="confirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="cancel" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { findSeaImportExcerption } from '@/api/SeaImport/seaImportJob'

export default {
  name: 'ImportPromptTitleDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    lob: { type: String, required: true }
  },
  data() {
    return {
      selectedRow: null,
      selectTypeNames: TYPE_NAMES,
      elForm: {
        jobNo: '',
        shipper: '',
        consignee: '',
        notify: '',
        loadingPortCode: '',
        mbl: ''
      },
      etdDate: '',
      innerVisible: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      columnDefs: [
        {
          headerName: this.$t('Payment.businessNumber'),
          field: 'jobNo'
        }, {
          headerName: this.$t('SeaExport.ShipperId'),
          tooltip: (params) => {
            return params.data.shipperCode
          },
          field: 'shipperCode'
        }, {
          headerName: this.$t('SeaExport.ShipperInfo'),
          tooltip: (params) => {
            return params.data.shipperLine
          },
          field: 'shipperInfo',
          cellRenderer: this.multipleDataRellRenderer
        }, {
          headerName: this.$t('SeaExport.ConsigneeId'),
          tooltip: (params) => {
            return params.data.consigneeCode
          },
          field: 'consigneeCode'
        }, {
          headerName: this.$t('SeaExport.ConsigneeInfo'),
          tooltip: (params) => {
            return params.data.consigneeLine
          },
          field: 'consigneeInfo',
          cellRenderer: this.multipleDataRellRenderer
        }, {
          headerName: this.$t('SeaExport.NotifyId'),
          tooltip: (params) => {
            return params.data.notifyCode
          },
          field: 'notifyCode'
        }, {
          headerName: this.$t('SeaExport.NotifyInfo'),
          tooltip: (params) => {
            return params.data.notifyLine
          },
          field: 'notifyInfo',
          cellRenderer: this.multipleDataRellRenderer
        }
      ],
      rowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          const selectedNode = nodes[event.rowIndex]
          if (selectedNode) {
            this.selectedRow = selectedNode.data
          } else {
            this.selectedRow = null
          }
        }
      }
    }
  },
  watch: {
    visible: {
      async handler(newVal) {
        this.innerVisible = newVal
      },
      immediate: true
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    getValueFromChild(obj) {
      this.elForm[obj.key] = obj.value
    },
    multipleDataRellRenderer(params) {
      if (params.value !== undefined) {
        return params.value.replace(/<br\/>/g, '<br/>')
      }
      return ''
    },
    async search() {
      const elForm = this.elForm
      const params = {}
      params.lob = this.lob
      params.branchId = this.$store.getters.currentOfficeId
      if (elForm.jobNo !== null && elForm.jobNo.trim().length > 0) {
        params.jobNo = elForm.jobNo.trim()
      }

      if (elForm.shipper !== null && elForm.shipper.trim().length > 0) {
        params.shipper = elForm.shipper.trim()
      }
      if (elForm.consignee !== null && elForm.consignee.trim().length > 0) {
        params.consignee = elForm.consignee.trim()
      }
      if (elForm.notify !== null && elForm.notify.trim().length > 0) {
        params.notify = elForm.notify.trim()
      }
      if (this.lob === 'AI') {
        if (elForm.loadingPortCode !== null && elForm.loadingPortCode.trim().length > 0) {
          params.loadingPortCode = elForm.loadingPortCode.trim()
        }
        if (elForm.mbl !== null && elForm.mbl.trim().length > 0) {
          params.mbl = elForm.mbl.trim()
        }
      }
      findSeaImportExcerption(params)
        .then(result => {
          this.rowData = result.data
        })
        .catch(message => {
          this.$message.error(message)
        })
    },
    reset() {
      const elForm = this.elForm
      elForm.jobNo = ''
      elForm.shipper = ''
      elForm.consignee = ''
      elForm.notify = ''
      elForm.loadingPortCode = ''
      elForm.mbl = ''
    },
    confirm() {
      this.$logger.log('selectedRow', this.selectedRow)
      if (!this.selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$emit('selected', this.selectedRow)
      this.innerVisible = false
    },
    cancel() {
      this.innerVisible = false
      this.reset()
    }
  }
}
</script>

<style lang="scss">
.edi-bill-search-selector {
  label {
    font-size: 12px;
    font-weight: normal;
  }
  .el-select {
    width: 100%;
  }
}
</style>
